import CommonUtil from "../utils/CommonUtil";

class RequestHandler {
  constructor(handler, callPreparer, callPerformer) {
    this._callPreparer = handler ? handler._callPreparer : callPreparer;
    this._callPerformer = handler ? handler._callPerformer : callPerformer;

    this._handler = handler ? handler : this;

    if (this._isHandler()) {
      this._pendedRequests = {};
      this._pendingIdCounter = 0;
    }
  }

  _isHandler = () => {
    return Object.is(this._handler, this);
  };

  hasPending = () => {
    return CommonUtil.objectHasAnyProperty(this._pendedRequests);
  };

  performPendedCalls = () => {
    if (this._isHandler() && this.hasPending()) {
      Object.keys(this._pendedRequests).forEach(key => {
        this._callPreparer(this._pendedRequests[key][0]());
      });
      this._callPerformer();
      this._pendedRequests = {};
    }
  };

  pendCall = (callType, call, data) => {
    if (this._isHandler()) {
      const isExisting = data.id !== undefined;
      data._pendingId = data._pendingId
        ? data._pendingId
        : isExisting
        ? data.id
        : --this._pendingIdCounter;

      if (callType === "delete" && !isExisting) {
        delete this._pendedRequests[data._pendingId];
      } else {
        this._pendedRequests[data._pendingId] = [call];
      }
    } else {
      this._handler.pendCall(callType, call, data);
    }
  };
}

export default RequestHandler;
